







































































import { Component, Vue } from "vue-property-decorator";
import RouteNames from "@/router/RouteNames";
import CompanySearch from "@/components/common/CompanySearch.vue";
import CompanyDTO from "@/dto/company/CompanyDTO";
import Notifications from "@/state/Notifications";

@Component({
	components: { CompanySearch }
})
export default class AdminPoliciesView extends Vue {
	private selectedCompany: CompanyDTO | null = null;
	private RouteNames = RouteNames;

	private get companyId(): number | null {
		return this.selectedCompany && this.selectedCompany.id != null ? this.selectedCompany.id : null;
	}

	private onSlpClick() {
		Notifications.warning(this.$t("payroll.adminPoliciesComingSoon") as string);
	}

	private onHaopClick() {
		Notifications.warning(this.$t("payroll.adminPoliciesComingSoon") as string);
	}
}
